interface TeamMember {
	number: string;
	name: string;
	nameEn: string;
	role: string;
	roleEn: string;
	image: string;
	bio: string;
	social: {
		instagram: string;
		tiktok: string;
	};
}

const members: TeamMember[] = [
	{
		number: "01",
		name: "ミヤタコーヘイ",
		nameEn: "Kohei Miyata",
		role: "音楽デザイナー",
		roleEn: "Jazz Cellist",
		image: "/images/welcome/welcome-profile-miyata.jpg",
		bio: "2歳からピアノ、3歳でチェロをはじめ、幼少期より演奏活動を開始。ルールに縛られたクラシック音楽に嫌気がさし、クラシックの反逆者として、そして自由な音楽を求めて音楽デザイナー/即興音楽家として活動。音楽にまつわるすべてを再発明すべく、blackadderのプロデュースを担う。",
		social: {
			instagram: "https://www.instagram.com/miyatako_hei/",
			tiktok: "https://www.tiktok.com/@miyata_ko_hei",
		},
	},
	{
		number: "02",
		name: "小畑和彰",
		nameEn: "Kazuaki Obata",
		role: "Webエンジニア",
		roleEn: "Pianist",
		image: "/images/welcome/welcome-profile-butter.jpg",
		bio: "3歳からクラシックピアノをはじめ、現在は人生を豊かにするための趣味としてジャズ・ポップなどを中心に演奏活動をしている。本業はウェブエンジニア。blackadderのWebサービス開発のすべてを担う。",
		social: {
			instagram: "https://www.instagram.com/butter251aug/",
			tiktok: "https://www.tiktok.com/@kazuakiobata",
		},
	},
];

export default function TeamSection() {
	return (
		<section id="team" className="relative py-28 2xl:py-40 bg-[#0a0a0a]">
			<div className="container px-6 mx-auto">
				<div className="max-w-6xl mx-auto">
					{/* Header */}
					<div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-20">
						<div>
							<p className="text-xs tracking-[0.3em] uppercase text-neutral-500 mb-4">
								Team
							</p>
							<h2 className="text-3xl md:text-4xl font-light text-white tracking-tight">
								音楽とテクノロジーで未来を創る
							</h2>
						</div>
						<p className="text-sm text-neutral-500 max-w-xs leading-relaxed">
							blackadderを共同で創業した<br />2人のメンバーを紹介します
						</p>
					</div>

					{/* Members */}
					<div className="grid grid-cols-1 lg:grid-cols-2 gap-x-12 2xl:gap-x-20">
						{members.map((member, index) => (
							<div
								key={member.number}
								className={`group ${index === 1 ? "lg:mt-24" : ""}`}
							>
								{/* Image */}
								<div className="relative overflow-hidden mb-8">
									<div className="overflow-hidden">
										<img
											className="w-full aspect-[4/5] object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-[1.04]"
											src={member.image}
											alt={member.name}
											loading="lazy"
											decoding="async"
										/>
									</div>
									{/* Number overlay */}
									<span className="absolute top-6 left-6 text-[11px] tracking-[0.2em] text-white/50 font-light">
										{member.number}
									</span>
								</div>

								{/* Info */}
								<div className="mb-16 lg:mb-24">
									{/* Role line */}
									<div className="flex items-center gap-3 mb-4">
										<div className="h-px w-8 bg-neutral-600" />
										<span className="text-xs tracking-[0.15em] uppercase text-neutral-500">
											{member.role}
											<span className="text-neutral-600 mx-1.5">/</span>
											{member.roleEn}
										</span>
									</div>

									{/* Name */}
									<h3 className="text-2xl md:text-3xl text-white font-light tracking-tight mb-2">
										{member.name}
									</h3>
									<p className="text-xs tracking-[0.1em] text-neutral-600 mb-6">
										{member.nameEn}
									</p>

									{/* Bio */}
									<p className="text-sm text-neutral-400 leading-[1.9] mb-6 max-w-md">
										{member.bio}
									</p>

									{/* Social */}
									<div className="flex items-center gap-4">
										<a
											className="flex items-center gap-2 text-xs text-neutral-600 hover:text-neutral-300 transition-colors duration-300"
											href={member.social.instagram}
											target="_blank"
											rel="noopener noreferrer"
										>
											<img
												className="h-3.5 opacity-30 group-hover:opacity-50 transition-opacity duration-300"
												src="/images/icons/instagram-w.png"
												alt="instagram"
											/>
											<span>Instagram</span>
										</a>
										<span className="text-neutral-800">|</span>
										<a
											className="flex items-center gap-2 text-xs text-neutral-600 hover:text-neutral-300 transition-colors duration-300"
											href={member.social.tiktok}
											target="_blank"
											rel="noopener noreferrer"
										>
											<img
												className="h-3.5 opacity-30 group-hover:opacity-50 transition-opacity duration-300"
												src="/images/icons/tiktok-w.png"
												alt="tiktok"
											/>
											<span>TikTok</span>
										</a>
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</section>
	);
}
